import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=4485ac04&scoped=true"
import script from "./AddressView.vue?vue&type=script&lang=js"
export * from "./AddressView.vue?vue&type=script&lang=js"
import style0 from "./AddressView.vue?vue&type=style&index=0&id=4485ac04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485ac04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4485ac04')) {
      api.createRecord('4485ac04', component.options)
    } else {
      api.reload('4485ac04', component.options)
    }
    module.hot.accept("./AddressView.vue?vue&type=template&id=4485ac04&scoped=true", function () {
      api.rerender('4485ac04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Address/AddressView.vue"
export default component.exports